import { useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useAuthCookie from "shared/model/useLoginCookie"
import useRoleCookie from "shared/model/useRoleCookie"
import useNameCookie from "shared/model/useNameCookie"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePostAdminLogin = (idRef, pwRef) => {
    const [fetchResult, fetchRequest] = useFetch()
    const [, setAuthCookie] = useAuthCookie()
    const [, setRoleCookie] = useRoleCookie()
    const [, setNameCookie] = useNameCookie()
    const [, setAlert] = useAlertModalAtom()

    const postRequest = () => {
        fetchRequest("POST", "/admin/auth/login", {
            "id": idRef.current.value,
            "password": pwRef.current.value
        })
    }

    const clickEvent = () => {
        postRequest()
    }

    const enterEvent = (e) => {
        if (e.key === "Enter") postRequest()
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                setAuthCookie(fetchResult?.data?.token)
                setRoleCookie(fetchResult?.data?.role)
                setNameCookie(fetchResult?.data?.name)
                break
            case 400:
                if (fetchResult?.data?.error_code === "id") setAlert("아이디를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "password") setAlert("비밀번호를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 403:
                if (fetchResult?.data?.error_code === 1) setAlert("아직 승인되지 않은 계정입니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("계정 정보가 존재하지 않습니다.")
                break

        }
    }, [fetchResult])


    return [clickEvent, enterEvent]
}

export default usePostAdminLogin